var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',_vm._b({staticClass:"graphic-source align-center justify-center",class:{ round: _vm.round },on:{"click":function($event){return _vm.$emit('click')}}},'v-img',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }